(function () {
    "use strict";
    angular
        .module("skillBuilderSaaS")
        .directive("configureStorefront", function () {
        return {
            restrict: "E",
            scope: {},
            bindToController: true,
            templateUrl: "app/learningPaths/version/storefrontConfig/configureStorefrontView.html",
            controller: ["learningPathVersionStorefrontResource", "frameworkService", "$state", ConfigureStorefrontCtrl],
            controllerAs: "vm"
        };
        function ConfigureStorefrontCtrl(learningPathVersionStorefrontResource, frameworkService, $state) {
            var vm = this;
            vm.loading = true;
            vm.catalogEnabled = frameworkService.data.tenantFeatures.storefront || frameworkService.data.tenantFeatures.catalog;
            vm.storefrontEnabled = frameworkService.data.tenantFeatures.storefront;
            vm.number = $state.params.number;
            vm.version = $state.params.version;
            vm.showErrors = false;
            vm.model = learningPathVersionStorefrontResource.get({ number: vm.number, version: vm.version }, function () {
                vm.loading = false;
            });
            if ($state.current.name === "main.learningItems.learningPathVersionStorefront") {
                $state.go("main.learningItems.learningPathVersionStorefront.information", { number: vm.number, version: vm.version });
            }
        }
    });
}());
